import { useState, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { message } from 'core/components/ui'
import RequesterGlobal, { requesterGlobalMethods } from 'core/requesters/RequesterGlobal'

const useGetOffer = props => {
  const { redirectMessage } = props

  const [price, setPrice] = useState(null)
  const [vehicle, setVehicle] = useState(null)
  const [loading, setLoading] = useState(false)
  const [futherInformations, setFutherInformations] = useState(null)
  const [user, setUser] = useState(null)
  const [comment, setComment] = useState(null)
  const [errorMessage, setErrorMessage] = useState(null)
  const [errorCode, setErrorCode] = useState(null)

  const intl = useIntl()

  const createTradeIn = () => {
    const params = {
      vehicle: {
        ...vehicle,
        origin: 1,
        financing: futherInformations.funding
      },
      user,
      furtherInformations: [futherInformations.purchase],
      comment
    }

    RequesterGlobal.get(requesterGlobalMethods.CREATE_TRADE_IN, params, redirectMessage)
      .then(datas => {
        setPrice({ amount: datas.price })
      })
      .catch(e => {
        let errMessage = e
        let errCode = 500

        if (e.includes('429')) {
          errMessage = intl.formatMessage({ id: 'error-429-title' })
          errCode = 429
        }

        message.error(errMessage)
        setErrorMessage(errMessage)
        setErrorCode(errCode)
      })
      .finally(() => setLoading(false))
  }

  const getOffer = params => {
    setLoading(true)
    setFutherInformations(params.futherInformations)
    setComment(params.comment)
    setVehicle(params.vehicle)
    setUser(params.user)
  }

  useEffect(() => {
    if (vehicle && user) createTradeIn()
  }, [vehicle, user])

  return {
    getOffer,
    loading,
    price,
    errorMessage,
    errorCode
  }
}

export default useGetOffer
